"use strict";
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalize = void 0;
var path_1 = require("path");
Object.defineProperty(exports, "normalize", { enumerable: true, get: function () { return path_1.normalize; } });
//# sourceMappingURL=normalize.js.map